export default __webpack_public_path__ + "static/media/navigation_transition-left.0348a228.ogg";